import React from 'react';
import { Button } from '@/components/ui/button';

import type { OpenCandidatesActionFn, ProgramControlCommonProps } from '../controlTypes';

type LaiProgramControlsProps = ProgramControlCommonProps & {
  onOpenCandidatesAction: OpenCandidatesActionFn;
};

export const LaiProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  onOpenCandidatesAction,
}: LaiProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex items-center gap-3">
      <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Facility</div>
      <div className="flex flex-wrap items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-facility" checked={values.laiFacilityFilter === 'all'} onChange={() => onFilterChange('laiFacilityFilter', 'all')} />All</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-facility" checked={values.laiFacilityFilter === 'TTCF'} onChange={() => onFilterChange('laiFacilityFilter', 'TTCF')} />TTCF</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-facility" checked={values.laiFacilityFilter === 'CRDF'} onChange={() => onFilterChange('laiFacilityFilter', 'CRDF')} />CRDF</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-facility" checked={values.laiFacilityFilter === 'MCJ'} onChange={() => onFilterChange('laiFacilityFilter', 'MCJ')} />MCJ</label>
        <label className="flex items-center gap-1.5"><input type="radio" name="lai-facility" checked={values.laiFacilityFilter === 'NCCF/PDC'} onChange={() => onFilterChange('laiFacilityFilter', 'NCCF/PDC')} />NCCF/PDC</label>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onOpenCandidatesAction('court-list-report')}>
        {renderReportActionLabel('+ Patient List Report')}
      </Button>
    </div>
  </div>
);

